import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';

console.info(
  '%c👋 Coucou, explorateur·rice du web !%c\nTu es bien curieux ! Profite bien du ride et pense à hydrater ton cache.',
  'color: #9b51e0; font-size: 14px; font-weight: 700;',
  'color: #2d9cdb; font-size: 13px;'
);

console.info(
  String.raw` ____ ____ ____ ____ ____
||M |||A |||G |||I |||C ||
||__|||__|||__|||__|||__||
|/__\|/__\|/__\|/__\|/__\|
 ____ ____ ____ ____      
||P |||A |||R |||K ||     
||__|||__|||__|||__||     
|/__\|/__\|/__\|/__\|     
 ____ ____ ____ ____ ____ 
||T |||I |||M |||E |||S ||
||__|||__|||__|||__|||__||
|/__\|/__\|/__\|/__\|/__\|`
);

console.info(
  String.raw`M"""""'""""'YM MMP"""""""MM MM'"""""'MM M""M MM'""""'YMM 
M  mm.  mm.  M M' .mmmm  MM M' .mmm. 'M M  M M' .mmm. 'M 
M  MMM  MMM  M M         'M M  MMMMMMMM M  M M  MMMMMooM 
M  MMM  MMM  M M  MMMMM  MM M  MMM   'M M  M M  MMMMMMMM 
M  MMM  MMM  M M  MMMMM  MM M. 'MMM' .M M  M M. 'MMM' .M 
M  MMM  MMM  M M  MMMMM  MM MM.     .MM M  M MM.     .dM 
MMMMMMMMMMMMMM MMMMMMMMMMMM MMMMMMMMMMM MMMM MMMMMMMMMMM 
                                                          
MM"""""""'YM MMP"""""""MM MM"""""""'MM M""MMMMM""M       
MM  mmmmm  M M' .mmmm  MM MM  mmmm,  M M  MMMM' .M       
M'        .M M         'M M'        .M M       .MM       
MM  MMMMMMMM M  MMMMM  MM MM  MMMb. "M M  MMMb. YM       
MM  MMMMMMMM M  MMMMM  MM MM  MMMMM  M M  MMMMb  M       
MM  MMMMMMMM M  MMMMM  MM MM  MMMMM  M M  MMMMM  M       
MMMMMMMMMMMM MMMMMMMMMMMM MMMMMMMMMMMM MMMMMMMMMMM       
                                                          
M""""""""M M""M M"""""'""""YM MM"""""""'M MP""""""'MM  
Mmmm  mmmM M  M M  mm.  mm.  M MM  mmmmmmmM M  mmmmm..M  
MMMM  MMMM M  M M  MMM  MMM  M M'      MMMM M.      'YM  
MMMM  MMMM M  M M  MMM  MMM  M MM  MMMMMMMM MMMMMMM.  M  
MMMM  MMMM M  M M  MMM  MMM  M MM  MMMMMMMM M. .MMM'  M  
MMMM  MMMM M  M M  MMM  MMM  M MM        .M Mb.     .dM  
MMMMMMMMMM MMMM MMMMMMMMMMMMMM MMMMMMMMMMMM MMMMMMMMMMM  `
);

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
